<template>
  <v-card
    class="rdatatagcard box-shadow-custom"
    max-width="240"
  >
    <div class="pa-4">
      <div class="rdatatagcard--header d-flex mb-2">
        <span
          class="rdatatagcard--title text-truncate"
          :title="name"
        >{{ name }}</span>
        <v-icon class="rdatatagcard--icon ml-2">
          {{ DASHBOARD_TYPE_TO_ICON[DASHBOARD_TYPES.TAG] }}
        </v-icon>
      </div>

      <div class="rdatatagcard--body d-flex">
        <div class="flex-expand">
          <p class="rdatatagcard--numproducts mb-1">
            {{ numProducts !== 1 ?
              $t('resources.productCount', { numProducts }) : '1' + $t('resources.product') }}
          </p>
          <p class="rdatatagcard--numurls mb-0">
            {{ numUrls !== 1 ?
              $t('resources.urlCount', { numUrls }) : '1' + $t('resources.url') }}
          </p>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { DASHBOARD_TYPES, RESOURCE_TYPE_TO_ICON } from '@/utils/constants'

export default {
  name: 'RDataTagCard',
  props: {
    name: {
      type: String,
      required: true,
    },
    numProducts: {
      type: Number,
      default: 0,
    },
    numUrls: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    DASHBOARD_TYPES,
    DASHBOARD_TYPE_TO_ICON: RESOURCE_TYPE_TO_ICON,
  }),
}
</script>

<style scoped>
.rdatatagcard--title {
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
}
.rdatatagcard--icon {
  flex: 0 0;
}
/deep/ .rdatatagcard--footer .v-icon {
  margin-top: -2px;
}
.rdatatagcard--body p {
  font-size: 12px;
}
.flex-expand {
  flex: 1;
}
</style>
